import React from 'react'
import classNames from 'classnames'
import { BadgeMDSProps } from './BadgeMDS.d'

const BadgeMDS = ({ badgeText, classes, icon, variation }: BadgeMDSProps) => {
  const isLargeBadge = ['Context - Brand', 'Power Stat'].includes(variation)
  const iconUrl = icon?.file?.url

  let bgColor
  let iconSize = '12'
  switch (variation) {
    case 'Misc':
      bgColor = 'bg-badge-misc'
      break
    case 'New':
      bgColor = 'bg-badge-new'
      break
    case 'Featured':
      bgColor = 'bg-badge-featured'
      break
    case 'Promotion':
      bgColor = 'bg-badge-promotion'
      break
    case 'Context - Neutral':
      bgColor = 'bg-badge-context-neutral'
      break
    case 'Context - Brand':
      bgColor = 'bg-badge-context-brand'
      iconSize = '20'
      break
    case 'Power Stat':
      bgColor = 'bg-badge-powerStat'
      iconSize = '24'
      break
    default:
      break
  }

  const badgeClasses = classNames(
    classes,
    bgColor,
    'inline-flex items-center leading-badge',
    {
      'rounded-badge py-1 px-2':
        !isLargeBadge || (variation === 'Context - Brand' && !iconUrl),
      'text-white': variation === 'Misc',
      'text-badge-color-standard': !['Misc', 'Power Stat'].includes(variation),
      'uppercase font-semibold text-badge tracking-badge font-sansPro':
        variation !== 'Power Stat',
      'text-badge-powerStat text-badge-color-powerStat p-2 pr-4 rounded-button font-effra':
        variation === 'Power Stat',
      'border border-badge-context-brand': variation === 'Context - Brand',
      'p-1 pr-4 rounded-button': variation === 'Context - Brand' && iconUrl,
      'pl-4': variation === 'Power Stat' && !iconUrl
    }
  )

  const iconWrapperClasses = classNames('block', {
    'mr-1': variation !== 'Context - Brand',
    'mr-2 bg-brand p-1 rounded-full inline-block h-full':
      variation === 'Context - Brand'
  })

  return (
    <div className={badgeClasses} data-testid='BadgeMDS'>
      {iconUrl ? (
        <span className={iconWrapperClasses}>
          <img
            alt=''
            className='block'
            src={`${iconUrl}?h=${iconSize}&w=${iconSize}&fit=scale`}
          />
        </span>
      ) : null}
      {badgeText}
    </div>
  )
}

export default BadgeMDS
